import Phaser from 'phaser';

export default class BalloonContainer extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.possibleSpawnRects = null;
    this.spawnWidth = 800;
    this.boxH = 82;
    this.boxW = 72;
    this.spotPool = null;

    this.balloonToPop = null;

    this.spawnHeight = 390;
    this.initializePossiblePositions();
    this.resetPool();
  }

  initializePossiblePositions () {
    this.possibleSpawnRects = [];
    const spawnWidth = this.spawnWidth;
    const spawnHeight = this.spawnHeight;
    const boxW = this.boxW;
    const boxH = this.boxH;
    const rowCount = Math.floor(spawnWidth / boxW);
    const columnCount = Math.floor(spawnHeight / boxH);

    const x0 = (this.scene.scale.width - this.spawnWidth) / 2;
    const y0 = boxH / 2;
    let x1; let y1; let sR;
    for (let i = 0; i < rowCount; i++) {
      for (let j = 0; j < columnCount; j++) {
        x1 = x0 + boxW * i;
        y1 = y0 + boxH * j;
        sR = { x: x1 + boxW / 2,y: y1 + boxH / 2,width: boxW,height: boxH };
        this.possibleSpawnRects.push(sR);
      }
    }
  }

  resetPool () {
    this.spotPool = JSON.parse(JSON.stringify(this.possibleSpawnRects));
  }

  getSpot () {
    if (this.spotPool.length < 0) {
      this.resetPool();
    }
    const index = Phaser.Math.Between(0,this.spotPool.length - 1);
    const item = this.spotPool.splice(index,1)[0];
    item.x += Phaser.Math.Between(1,8) - 4;
    item.y += Phaser.Math.Between(1,8) - 4;
    return item;
  }
}